module.exports = __webpack_public_path__ + "img/left-arrow.2b686ce7.svg";